/**
@ngdoc directive
@name calcSumList

@description
Calculate Sum of a List

	//Standard use
	calc-sum-list="[0,1,2,3,4] | [{aKey:0},{aKey:1},{aKey:2},{aKey:3},{aKey:4}]" //(Required) list that you wish to find the sum total
	calc-sum-list-result="anAngularVar" //(Required) The angular var you wish the result to be outputted too

	//Object use
	calc-sum-list-property="aKey" //(Optional) If the list provided is a list of objects,
									you must provided which property key you wish to sum

	//Numerical fine tuning
	calc-sum-list-decimals="^[0-9]" //(Optional) Number of decimal places for answer. If not present defaults to zero = Integer.

	//Time based addition sums - list must be an object
	calc-sum-list-property-minute="minuteKey" //(Optional) Minute part. calc-sum-list-property will act as the hour part of result
	calc-sum-list-result-minute="minuteResultKey" //(Optional) Minute part of result. calc-sum-list-result will act as the hour part of result

@usage
	http://localhost:8080/testSearch/angularSums
	<!-- Standard sum addition of integers (note decimals is optional) -->
	<input type="number" name="total.duration" ng-model="formModel.total.duration" value="0"
		calc-sum-list="[0,1,2,3,4]"
		calc-sum-list-result="formModel.total.duration"
		calc-sum-list-decimals="0" />

	<!-- Object sum addition of decimals -->
	<input type="number" name="total.duration" ng-model="formModel.total.duration" value="0"
		calc-sum-list="[{aKey:0},{aKey:1},{aKey:2},{aKey:3},{aKey:4}]"
		calc-sum-list-property="aKey"
		calc-sum-list-result="formModel.total.duration"
		calc-sum-list-decimals="2" />

	<!-- Object sum addition of decimals -->
	<span calc-sum-list="formModel.timeRecordDailyList"
		calc-sum-list-property="duration"
		calc-sum-list-result="formModel.total.duration"
		calc-sum-list-decimals="2">{{formModel.total.duration}}</span>

	<!-- Object sum addition of time parts -->
	<span calc-sum-list="[{hourKey:0, minuteKey:15},{hourKey:1, minuteKey:30},{hourKey:2, minuteKey:45}]"
		calc-sum-list-property="hourKey"
		calc-sum-list-property-minute="minuteKey"
		calc-sum-list-result="formModel.total.hour"
		calc-sum-list-result-minute="formModel.total.minute"></span>
	<input type="number" name="total.hour" ng-model="formModel.total.hour" value="0" />
	<input type="number" name="total.minute" ng-model="formModel.total.minute" value="0" />


*/
(function() {
	'use strict';

	var calcSumList = function($timeout, mathService, durationService) {
		return {
			restrict: "A",
			scope: true,
			bindToController: {
			   list: "=calcSumList", //May be an ArrayList or ObjectList
			   result: "=calcSumListResult",
			   property: "@calcSumListProperty",
			   decimals: "@calcSumListDecimals", //Deals with errors like 0.5 - 0.33 = 0.16999999999999998
			   propertyMinute: "@calcSumListPropertyMinute",
			   resultMinute: "=calcSumListResultMinute"
			},
			controllerAs: 'ctrl',
			controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

				var DEBUG = false;
				var _this = this;

				var decimals,
					resultValueOrObject, //result may be a Number or Object{hour:Number,minute:Number};
					isPropertyDefined,
					isDuration;

				_this.$onInit = function(){
					if(!angular.isDefined(_this.list)) {
						throw 'Exception (calcSumList.js): calc-sum-list is undefined'; //required property check
					}

					//set decimals or use default of zero
					decimals = angular.isDefined(_this.decimals) ? _this.decimals : 0;

					//If Array<Object>, property should be defined
					//If Array<Number>, property should not be defined
					isPropertyDefined = angular.isDefined(_this.property);

					//If a minute property is defined we're dealing with durations
					isDuration = angular.isDefined(_this.propertyMinute) && angular.isDefined(_this.resultMinute);

					if(DEBUG){
						console.log('calcSumList() isPropertyDefined:', isPropertyDefined);
						console.log('calc-sum-list:', _this.list);
						console.log('calc-sum-list boolean isPropertyDefined:', isPropertyDefined);
						console.log('calc-sum-list boolean isDuration:', isDuration);
						console.log('calc-sum-list-property:', _this.property);
						console.log('calc-sum-list-property-minute:', _this.propertyMinute);
						console.log('calc-sum-list-decimals:', _this.decimals);
						console.log('calc-sum-list-result:', _this.result);
						console.log('calc-sum-list-result-minute:', _this.resultMinute);
					}
				}

				// onload // this probably can be moved inside $onInit too
				$timeout(function(){
					calculateSum(_this.list);
				});


				//Watch for changes in the list
				//Note: An efficiency gain would be to only watch for changes in property in list!
				$scope.$watch(
					function(){
						return _this.list;
					},
					function(newValueOrObject, oldValueOrObject){ //oldVal & newVal are sum-calc-list object
						if(newValueOrObject != oldValueOrObject) {
							calculateSum(newValueOrObject);
						}
					},
					true
				);


				function calculateSum(newValueOrObject){

					if(isPropertyDefined && isDuration){
						resultValueOrObject = durationService.hourMinute.duration(0,0);
					} else {
						resultValueOrObject	= 0;
					}

					angular.forEach(newValueOrObject, function(valueOrObject){
						if( !isPropertyDefined ){
							//Standard sum addition of integers or decimals
							resultValueOrObject += mathService.roundFromString( valueOrObject , decimals );
						} else if ( !isDuration ){
							var objectPropertyDayClaimed = valueOrObject[_this.property] ? valueOrObject[_this.property] :0
							resultValueOrObject += mathService.roundFromString( objectPropertyDayClaimed , decimals );
						} else {
							var objectPropertyHour = valueOrObject[_this.property] ? valueOrObject[_this.property] :0
							var objectPropertyMin =  valueOrObject[_this.propertyMinute] ? valueOrObject[_this.propertyMinute] :0
							resultValueOrObject.hour   += mathService.roundFromString( objectPropertyHour , decimals );
							resultValueOrObject.minute += mathService.roundFromString( objectPropertyMin , decimals );
						}

						if(DEBUG) {
							console.log('calcSumList() each resultValueOrObject:', resultValueOrObject);
						}

					});

					if(DEBUG) {
						console.log('calcSumList() end resultValueOrObject:', resultValueOrObject);
					}


					if( !isDuration ){
						//Round the final result
						_this.result 		= mathService.round( resultValueOrObject, decimals );
					} else {
						//Push the sum hours and sum minutes through duration service to re-base60 it
						resultValueOrObject = durationService.hourMinute.duration( resultValueOrObject.hour, resultValueOrObject.minute );
						_this.result 		= resultValueOrObject.hour;
						_this.resultMinute  = resultValueOrObject.minute;
					}


					if(DEBUG) {
						console.log('calcSumList() formatted resultValueOrObject:', resultValueOrObject);
						console.log('calc-sum-list-result', _this.result);
						console.log('calc-sum-list-result-minute', _this.resultMinute);
					}
				};

			}],
			replace: false,
			transclude: false
		};
	}
	calcSumList.$inject = ['$timeout', 'mathService', 'durationService'];
	angular.module('app').directive('calcSumList', calcSumList);

}());
